import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || 'https://api.cornerstoneint.in/api/',
});
// baseURL: process.env.REACT_APP_API_BASE_URL || 'http://localhost:5073/api/';,''https://api.cornerstoneint.in/api/''
// Request interceptor for adding authorization token
// api.interceptors.request.use(
//   (config) => {
//     const token = localStorage.getItem('token');
//     if (token) {
//       config.headers.Authorization = `Bearer ${token}`;
//     }
//     return config;
//   },
//   (error) => {
//     return Promise.reject(error);
//   }
// );

// Response interceptor for handling errors
// api.interceptors.response.use(
//   (response) => response.data,
//   (error) => {
//     if (error.response) {
//       // Handle different HTTP status codes
//       if (error.response.status === 401) {
//         // Handle unauthorized access
//         localStorage.removeItem('token');
//         window.location = '/login';
//       }
//       return Promise.reject(error.response.data);
//     }
//     return Promise.reject(error);
//   }
// );

export default api;